import { AppDispatch } from '@/store/store';
import { cacheDataForThread } from '@/store/reducers/TableWidgetStore';
import { cacheDvDataForThread } from '@/store/reducers/DataVoyagerWidgetStore';
import { getDataVoyagerWidgetDataFromApi } from '@/models/DataVoyager';
import { getTableWidgetDataFromApi } from '@/models/Table';
import { isPojo } from '@/utils/typeUtils';
import {
  openDataVoyagerWidget,
  openTableWidget,
} from '@/store/actionCreators/WidgetActions';

export function processDvWidgetPubsubEvent({
  threadId,
  widgetDataStr,
  dispatch,
}: {
  threadId: string;
  widgetDataStr: string;
  dispatch: AppDispatch;
}): void {
  const dvDataJSON = JSON.parse(widgetDataStr);
  const dvData = getDataVoyagerWidgetDataFromApi(dvDataJSON);
  if (!isPojo(dvData)) {
    return;
  }
  dispatch(
    cacheDvDataForThread({
      threadId,
      dvData,
    }),
  );
  dispatch(openDataVoyagerWidget({ currentThreadId: threadId, dvData }));
}

export function processTableWidgetPubsubEvent({
  threadId,
  widgetDataStr,
  dispatch,
}: {
  threadId: string;
  widgetDataStr: string;
  dispatch: AppDispatch;
}): void {
  const tableDataJSON = JSON.parse(widgetDataStr);
  const tableData = getTableWidgetDataFromApi(tableDataJSON);
  if (!isPojo(tableData)) {
    return;
  }
  dispatch(cacheDataForThread({ threadId, tableData }));
  dispatch(openTableWidget({ currentThreadId: threadId, tableData }));
}
